import {
  UPDATE_ALTERNATIVE_BOOKING_START,
  UPDATE_ALTERNATIVE_BOKING_SUCCESS,
  UPDATE_ALTERNATIVE_BOKINGL_ERROR,
  CANCEL_ALTERNATIVE_BOKINGL_START,
  CANCEL_ALTERNATIVE_BOKINGL_SUCCESS,
  CANCEL_ALTERNATIVE_BOKING_ERROR,
} from "Constant";

const initialState = {
  loading: false,
  data: [],
};

export default function UpdateAlternativeBookingReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case UPDATE_ALTERNATIVE_BOOKING_START:
      return { ...state, loading: true };
    case UPDATE_ALTERNATIVE_BOKING_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CANCEL_ALTERNATIVE_BOKINGL_START:
      return { ...state, loading: true };
    case CANCEL_ALTERNATIVE_BOKINGL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case UPDATE_ALTERNATIVE_BOKINGL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case CANCEL_ALTERNATIVE_BOKING_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
